import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=b8dae6e0&scoped=true"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=b8dae6e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dae6e0",
  null
  
)

export default component.exports